import types from '../actions/types'

const { FETCH_EC_MONEY_TRANSER } = types

function ecMoneyTransfer(state = [], action = {}) {
  switch (action.type) {
    case FETCH_EC_MONEY_TRANSER: {
      return action.state
    }

    default:
      return state
  }
}

export default ecMoneyTransfer
